import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { ErrorCodes, ErrorMessages } from './error.code';
import { Observable } from 'rxjs';

@Component({
    styleUrls: ['error.component.scss'],
    templateUrl: 'error.component.html'
})
export class ErrorComponent implements OnInit {

    public ErrorMessages = ErrorMessages;

    public code: ErrorCodes;

    constructor(
        private route: ActivatedRoute,
        private authService: AuthService,
    ) { }

    async ngOnInit() {
        this.code = this.route.snapshot.queryParams?.code || ErrorCodes.unknown;
    }

    public reload(): Observable<void> {
        if (this.code === ErrorCodes.fail_to_get_me) {
            return this.authService.logout({
                logoutParams: {
                    returnTo: `${window.location.origin}/login`
                }
            });
        }
        window.location.assign('');
    }
}
